import { render, staticRenderFns } from "./petition.vue?vue&type=template&id=0e5046f2&scoped=true&"
import script from "./petition.vue?vue&type=script&lang=js&"
export * from "./petition.vue?vue&type=script&lang=js&"
import style0 from "./petition.vue?vue&type=style&index=0&id=0e5046f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5046f2",
  null
  
)

export default component.exports